
  var _styles = {
  "hotel-card": {
    "display": "flex",
    "flexDirection": "row",
    "padding": "0.21333rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderWidth": "1px",
    "borderStyle": "solid",
    "borderColor": "rgb(255,255,255)",
    "width": "9.36rem",
    "borderRadius": "0.32rem",
    "marginTop": 0,
    "marginRight": "auto",
    "marginBottom": "0.16rem",
    "marginLeft": "auto"
  },
  "hotel-card__image-container": {
    "position": "relative",
    "width": "2.72rem",
    "height": "3.84rem",
    "marginRight": "0.21333rem",
    "borderRadius": "0.24rem",
    "overflow": "hidden"
  },
  "hotel-card__image": {
    "width": "100%",
    "height": "100%"
  },
  "hotel-card__recommended-badge": {
    "position": "absolute",
    "top": "0.10667rem",
    "left": "0.10667rem",
    "width": "0.42667rem",
    "height": "0.42667rem",
    "borderRadius": "0.21333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "hotel-card__recommended-icon": {
    "width": "0.26667rem",
    "height": "0.26667rem"
  },
  "hotel-card__content": {
    "flex": 1,
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between"
  },
  "hotel-card__info-container": {
    "flex": 1,
    "display": "flex",
    "flexDirection": "column"
  },
  "hotel-card__name": {
    "fontSize": "0.42667rem",
    "fontWeight": "600",
    "color": "rgb(34,34,34)",
    "lineHeight": "0.53333rem"
  },
  "hotel-card__comment": {
    "fontWeight": "400",
    "color": "rgb(0,64,153)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.37333rem",
    "height": "0.37333rem",
    "marginTop": "0.16rem"
  },
  "hotel-card__tags": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "marginTop": "0.16rem"
  },
  "hotel-card__tag": {
    "fontSize": "0.26667rem",
    "color": "rgb(136,136,136)",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "borderRadius": "0.08rem",
    "marginRight": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(204,204,204)",
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "height": "0.37333rem"
  },
  "hotel-card__location-row": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginTop": "0.16rem",
    "height": "0.4rem"
  },
  "hotel-card__location-icon": {
    "width": "0.32rem",
    "height": "0.32rem",
    "marginRight": "0.12rem"
  },
  "hotel-card__location": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.4rem"
  },
  "hotel-card__discount": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginTop": "0.34667rem"
  },
  "hotel-card__discount-icon": {
    "width": "0.32rem",
    "height": "0.32rem",
    "marginRight": "0.10667rem"
  },
  "hotel-card__discount-text": {
    "fontWeight": "400",
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.32rem"
  },
  "hotel-card__features": {
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)",
    "lineHeight": "0.42667rem",
    "marginBottom": "0.21333rem"
  },
  "position-icon": {
    "width": "0.26667rem",
    "height": "0.26667rem"
  },
  "fire-icon": {
    "width": "0.32rem",
    "height": "0.32rem",
    "marginRight": "0.06667rem"
  },
  "hotel-card__price-change-text": {
    "fontWeight": "400",
    "color": "rgba(17,25,37,0.6470588235)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.32rem"
  }
};



  module.exports = _styles;
  